import React from 'react';
import { CheckIcon, Trash2Icon } from 'lucide-react';
import { useAppState } from '../../contexts/AppStateContext';
import { DEMO_DATE } from '../../data/demo';
import { schoolKindLabels } from '../../data/labels';
import { addDays, daysUntil, formatDate, formatShortDay } from '../../utils/time';
import { EmptyNote } from '../ui/Panel';
export function SchoolList({
  memberIds
}: {
  memberIds: string[];
}) {
  const {
    db,
    family,
    memberById,
    viewer,
    isAdmin,
    toggleSchoolItem,
    toggleBlock,
    addBlock,
    deleteSchoolItem,
    canEditSchool
  } = useAppState();
  const items = db.schoolItems.filter(s => s.familyId === family.id && memberIds.includes(s.memberId) && (isAdmin || s.memberId === viewer.id)).sort((a, b) => a.date.localeCompare(b.date));
  if (items.length === 0) return <EmptyNote data-id="element-76" data-mp="tufdzhuwwwcc">Ni šolskih obveznosti. Ali si genij ali pa jih še nisi vpisal(a).</EmptyNote>;
  return <ul className="space-y-3" data-id="element-77" data-mp="ytsakubl5hs4">
      {items.map(s => {
      const d = daysUntil(DEMO_DATE, s.date);
      const editable = canEditSchool(s.memberId, s.createdBy);
      const canTick = isAdmin || s.memberId === viewer.id;
      return <li key={s.id} className={`rounded-3xl border-[1.5px] border-line bg-surface p-4 ${s.done ? 'opacity-70' : ''}`} data-id="element-78" data-mp="1hxirt2frrh64">
            <div className="flex items-start gap-3" data-id="element-79" data-mp="1rnkfvu84gzl1">
              <button type="button" disabled={!canTick} onClick={() => toggleSchoolItem(s.id)} aria-pressed={s.done} aria-label={`${s.title}: ${s.done ? 'označi kot odprto' : 'označi kot opravljeno'}`} className={`mt-0.5 grid h-7 w-7 shrink-0 place-items-center rounded-lg border-2 ${s.done ? 'border-done bg-done text-white' : 'border-[#C9BBA4] text-transparent hover:border-done'}`} data-id="element-80" data-mp="1rovi3plx5za1">
                <CheckIcon className="h-4 w-4" strokeWidth={3.5} aria-hidden="true" data-id="element-81" data-mp="2ocjnr84snzcp" />
              </button>
              <span className="min-w-0 flex-1" data-id="element-82" data-mp="2je8diwal7mty">
                <span className="flex flex-wrap items-center gap-2" data-id="element-83" data-mp="1h1lxnn7yzk9d">
                  <span className="rounded-full bg-info-soft px-2 py-0.5 text-xs font-bold text-info-ink" data-id="element-84" data-mp="1h3g827lm7tz7">{schoolKindLabels[s.kind]}</span>
                  {isAdmin && <span className="text-xs font-bold text-muted" data-id="element-85" data-mp="1q1s973k3ya5w">{memberById(s.memberId)?.name}</span>}
                </span>
                <span className={`mt-1 block font-bold ${s.done ? 'line-through' : ''}`} data-id="element-86" data-mp="1v0lbs0xuwgra">{s.title}</span>
                <span className={`block text-xs ${d <= 1 && !s.done ? 'font-bold text-accent-ink' : 'text-muted'}`} data-id="element-87" data-mp="ycf9vlsbk2gp">
                  {formatDate(s.date)} · {d < 0 ? 'mimo' : d === 0 ? 'danes!' : d === 1 ? 'jutri!' : `čez ${d} dni`}
                </span>
              </span>
              {editable && <button type="button" onClick={() => deleteSchoolItem(s.id)} aria-label={`Izbriši ${s.title}`} className="grid h-9 w-9 place-items-center rounded-xl text-muted hover:bg-canvas hover:text-accent-ink" data-id="element-88" data-mp="1c3k7kic4mkoe">
                  <Trash2Icon className="h-4 w-4" data-id="element-89" data-mp="jjllfav2kbzw" />
                </button>}
            </div>
            {(s.kind === 'test' || s.kind === 'sprasevanje') && <div className="mt-3 border-t border-line pt-3" data-id="element-90" data-mp="745dwb0es63g">
                <p className="text-xs font-bold text-muted" data-id="element-91" data-mp="23hmvpc6jp98">Priprava · {s.blocks.filter(b => b.done).length}/{s.blocks.length} blokov</p>
                <ul className="mt-2 flex flex-wrap gap-2" data-id="element-92" data-mp="3u7s8g646gc0z">
                  {s.blocks.map(b => <li key={b.id} data-id="element-93" data-mp="3pb1vvsrkzykb">
                      <button type="button" disabled={!canTick} onClick={() => toggleBlock(s.id, b.id)} aria-pressed={b.done} className={`inline-flex h-9 items-center gap-1.5 rounded-full border-[1.5px] px-3 text-xs font-bold capitalize ${b.done ? 'border-done bg-done-soft text-done-ink' : 'border-line bg-canvas'}`} data-id="element-94" data-mp="3khqmpkzar5p8">
                        {b.done && <CheckIcon className="h-3.5 w-3.5" aria-hidden="true" data-id="element-95" data-mp="31lqss4mrds30" />}
                        {formatShortDay(b.date)} · {b.minutes} min
                      </button>
                    </li>)}
                  {canTick && !s.done && <li data-id="element-96" data-mp="vpx3wy0xnygn">
                      <button type="button" onClick={() => addBlock(s.id, addDays(s.blocks[s.blocks.length - 1]?.date ?? DEMO_DATE, 1), 30)} className="inline-flex h-9 items-center rounded-full border-[1.5px] border-dashed border-line px-3 text-xs font-bold text-muted hover:text-ink" data-id="element-97" data-mp="vom0x0fbauql">
                        + učni blok
                      </button>
                    </li>}
                </ul>
              </div>}
          </li>;
    })}
    </ul>;
}